/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */
import Env from '@/env';
const apiVersion = 'api';
import AuthApis from '@/controllers/AuthApis';
import ProductApis from '@/controllers/ProductApis';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /**
   * Fetch all  location pos station
   */
  fetchAllLocationPosStation() {
    const url = `${Env.loginUrl}/${apiVersion}/location-pos-stations/all`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Add new  location pos station
   */
  addLocationPosStation(data) {
    const url = `${Env.loginUrl}/${apiVersion}/location-pos-stations/create`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Update  location pos station
   */
  updateLocationPosStation(locationPosStationId, data) {
    const url = `${Env.loginUrl}/${apiVersion}/location-pos-stations/${locationPosStationId}/update`;
    return AuthApis.patchApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Delete location pos station
   */
  deleteLocationPosStation(locationPosStationId) {
    const url = `${Env.loginUrl}/${apiVersion}/location-pos-stations/${locationPosStationId}/remove`;
    return AuthApis.deleteApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * View scanner verification
   */
  locationScannerVerification() {
    const url = `${Env.loginUrl}/${apiVersion}/location-inventory-verification/show`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Update scanner verification
   */
  updateLocationScannerVerification(data) {
    const url = `${Env.loginUrl}/${apiVersion}/location-inventory-verification/create`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * View product exempt
   */
  exemptProductVerification() {
    const url = `/product/exemptFromScanning/list`;
    return ProductApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Update product exempt
   */
  updateExemptProductVerification(data) {
    const url = `/product/exemptFromScanning/update`;
    return ProductApis.putApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

}